import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [openModal, setOpenModal] = useState<null | 'privacy' | 'terms'>(null);
  return <footer className="bg-brand-cream py-12 px-6 border-t border-brand-brown/10 text-center" data-id="element-27">
      <div className="max-w-4xl mx-auto" data-id="element-28">
        <p className="text-brand-text font-serif font-medium mb-4" data-id="element-29">
          © 2026 Sueño para BB en 7 Minutos
        </p>

        <nav className="flex items-center justify-center gap-6 mb-6" data-id="element-30">
          <button onClick={() => setOpenModal('privacy')} className="text-sm font-medium text-brand-brown hover:text-brand-brownHover underline underline-offset-4 transition-colors focus:outline-none focus:ring-2 focus:ring-brand-brown/30 rounded" data-id="element-31">
            Política de Privacidad
          </button>
          <span className="text-brand-brown/30" data-id="element-32">|</span>
          <button onClick={() => setOpenModal('terms')} className="text-sm font-medium text-brand-brown hover:text-brand-brownHover underline underline-offset-4 transition-colors focus:outline-none focus:ring-2 focus:ring-brand-brown/30 rounded" data-id="element-33">
            Términos y Condiciones
          </button>
        </nav>

        <p className="text-xs text-brand-textLight/70 max-w-2xl mx-auto leading-relaxed" data-id="element-34">
          Descargo de responsabilidad: La información proporcionada en este
          sitio web y en el protocolo es estrictamente para fines educativos e
          informativos. No pretende ser un sustituto del consejo, diagnóstico o
          tratamiento médico profesional. Siempre busque el consejo de su
          pediatra u otro proveedor de salud calificado con cualquier pregunta
          que pueda tener sobre la condición médica de su bebé.
        </p>
      </div>

      <LegalModal isOpen={openModal === 'privacy'} onClose={() => setOpenModal(null)} title="Política de Privacidad" data-id="element-35">
        <p data-id="element-36">
          Tu privacidad es importante para nosotros. Esta Política de Privacidad
          explica cómo tratamos la información en relación con el protocolo
          "Sueño para BB en 7 Minutos".
        </p>
        <h3 className="font-serif font-bold text-brand-text text-base md:text-lg pt-2" data-id="element-37">
          Información que recopilamos
        </h3>
        <p data-id="element-38">
          Únicamente recopilamos la información estrictamente necesaria para
          procesar tu acceso al producto digital, como el correo electrónico de
          entrega. No vendemos, alquilamos ni compartimos tus datos personales
          con terceros con fines de marketing.
        </p>
        <h3 className="font-serif font-bold text-brand-text text-base md:text-lg pt-2" data-id="element-39">
          Uso de la información
        </h3>
        <p data-id="element-40">
          La información se utiliza exclusivamente para entregarte el producto,
          brindarte soporte relacionado con tu compra y cumplir con obligaciones
          legales. No utilizamos tus datos para crear perfiles ni para
          publicidad invasiva.
        </p>
        <h3 className="font-serif font-bold text-brand-text text-base md:text-lg pt-2" data-id="element-41">
          Cookies
        </h3>
        <p data-id="element-42">
          Este sitio puede utilizar cookies básicas para garantizar su correcto
          funcionamiento y mejorar tu experiencia de navegación. Puedes
          desactivarlas desde la configuración de tu navegador en cualquier
          momento.
        </p>
        <h3 className="font-serif font-bold text-brand-text text-base md:text-lg pt-2" data-id="element-43">
          Seguridad de los datos
        </h3>
        <p data-id="element-44">
          Implementamos medidas razonables de seguridad para proteger tu
          información contra accesos no autorizados, alteraciones o
          divulgaciones.
        </p>
        <h3 className="font-serif font-bold text-brand-text text-base md:text-lg pt-2" data-id="element-45">
          Cambios a esta política
        </h3>
        <p data-id="element-46">
          Podemos actualizar esta Política de Privacidad ocasionalmente.
          Cualquier cambio será publicado en esta misma página.
        </p>
      </LegalModal>

      <LegalModal isOpen={openModal === 'terms'} onClose={() => setOpenModal(null)} title="Términos y Condiciones" data-id="element-47">
        <p data-id="element-48">
          Al adquirir y utilizar el protocolo "Sueño para BB en 7 Minutos",
          aceptas los siguientes Términos y Condiciones.
        </p>
        <h3 className="font-serif font-bold text-brand-text text-base md:text-lg pt-2" data-id="element-49">
          Naturaleza del producto
        </h3>
        <p data-id="element-50">
          El protocolo es un producto digital de carácter educativo e
          informativo. No constituye asesoramiento médico, diagnóstico ni
          tratamiento. Los resultados pueden variar de un bebé a otro.
        </p>
        <h3 className="font-serif font-bold text-brand-text text-base md:text-lg pt-2" data-id="element-51">
          Licencia de uso
        </h3>
        <p data-id="element-52">
          Al comprar, obtienes una licencia personal e intransferible para usar
          el contenido. Queda prohibida la reproducción, distribución o reventa
          total o parcial del material sin autorización expresa.
        </p>
        <h3 className="font-serif font-bold text-brand-text text-base md:text-lg pt-2" data-id="element-53">
          Responsabilidad
        </h3>
        <p data-id="element-54">
          El uso del protocolo es responsabilidad del usuario. Siempre debes
          consultar a tu pediatra o profesional de la salud antes de aplicar
          cualquier técnica relacionada con el cuidado de tu bebé. No nos
          hacemos responsables por el uso indebido de la información.
        </p>
        <h3 className="font-serif font-bold text-brand-text text-base md:text-lg pt-2" data-id="element-55">
          Pagos y acceso
        </h3>
        <p data-id="element-56">
          El acceso al producto se otorga una vez confirmado el pago. Al
          tratarse de un producto digital de descarga inmediata, aplican las
          condiciones de reembolso indicadas en el momento de la compra.
        </p>
        <h3 className="font-serif font-bold text-brand-text text-base md:text-lg pt-2" data-id="element-57">
          Modificaciones
        </h3>
        <p data-id="element-58">
          Nos reservamos el derecho de modificar estos Términos y Condiciones en
          cualquier momento. El uso continuado del producto implica la
          aceptación de dichos cambios.
        </p>
      </LegalModal>
    </footer>;
}